<div class="flex flex-col w-full gap-10">
    <div class="flex items-center justify-center">
      <span
        class="text-primary text-2xl border-[2px] border-transparent border-b-primary p-4"
      >
        Register Now</span
      >
    </div>
 <form
      [formGroup]="authForm"
      class="login-container gap-4 flex flex-col"
      (ngSubmit)="signIn()"
    >
    <div>
      <span>Email</span>
          <input
        placeholder="Enter your email"
        formControlName="email"
        name="email"
        type="email"
        class="w-full border p-2 rounded-md outline-none"
      />
      <div
        *ngIf="authForm.get('email')?.errors?.['required'] && authForm.get('email')?.touched"
        class="text-red-500"
      >
        Email is required
      </div>
    </div>
  
    <div class="items-center justify-center flex">
          <app-primary-button >
        <div class="gap-2 flex items-center" routerLink="/verify-email" >
          <img src="../../assets/image/Shape.png" alt="" class="h-4" />
          Register 
        </div>
      </app-primary-button>
    </div>
  </form> 
  
      
    <div *ngIf="false" class="login-buttons">
        <button (click)="loginWithGoogle()">
          <img src="../../../assets/image/envelope.png" alt="Google" />
          Signup with Google
        </button>
      
        <button (click)="loginWithFacebook()">
          <img src="../../../assets/image/facebook.png" alt="Facebook" />
          Signup with Facebook
        </button>
      </div>
    </div>
  
  <style>
    .login-buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin: 20px 0;
  }
  
  .login-buttons button {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 10px 16px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #f1f1f1;
    transition: background-color 0.3s ease;
  }
  
  .login-buttons button:hover {
    background-color: #e0e0e0;
  }
  
  .login-buttons img {
    width: 20px;
    height: 20px;
  }
  </style>
  